import React from "react";
import { IconButton } from "@mui/material";
import EditOutlined from "@mui/icons-material/EditOutlined";

import { type MachineGroup, type MachineGroupConfiguration } from "@/schemas";
import { useUpdateMachineGroup } from "@/hooks/machine-groups";

import { MachineGroupsConfigurationModal } from "../machine-groups-configuration-modal";

interface MachineGroupEditButtonProps {
	readonly machineGroup: MachineGroup;
}

export const MachineGroupEditButton: React.FC<MachineGroupEditButtonProps> = ({ machineGroup }) => {
	const [showEdit, setShowEdit] = React.useState(false);
	const { mutate: updateMachineGroupAsync, error } = useUpdateMachineGroup();

	const handleSubmit = async (data: MachineGroupConfiguration): Promise<void> => {
		try {
			await updateMachineGroupAsync({ ...machineGroup, ...data });
			setShowEdit(false);
		} catch {
			/* Handled */
		}
	};

	const defaultValues: MachineGroupConfiguration & { id: string } = {
		id: machineGroup.id,
		alias: machineGroup.alias,
		description: machineGroup.description ?? "",
		configuredMachinesWithMachineType: machineGroup.configuredMachinesWithMachineType,
		enableProductionAutomatically: machineGroup.enableProductionAutomatically ?? false,
	};

	return (
		<>
			<MachineGroupsConfigurationModal
				open={showEdit}
				onClose={() => setShowEdit(false)}
				onSubmit={handleSubmit}
				error={error}
				defaultValues={defaultValues}
			/>
			<IconButton
				onClick={() => setShowEdit(true)}
				data-testid="machine-group-edit-button__button__open-modal"
				data-cy="edit-button"
				data-pendoid="machine-groups__button__edit"
			>
				<EditOutlined sx={{ fontSize: 24, color: "text.primary" }} />
			</IconButton>
		</>
	);
};
